// extracted by css-extract-rspack-plugin
export default {"notes":"J5Bw1J1NvU8d3v0b","label":"yUweVdfeZLAGX8Ye","text":"uAsvKDKznrYrBmNj","alertText":"m1kfKRl1lqgE1uyL","container":"LwPHKiQAXwkSxZcE"};